<ngx-loading-bar [includeSpinner]="false" [color]="ngxLoadingBarColor"></ngx-loading-bar>
<div class="iq-portal"><router-outlet></router-outlet></div>
